// extracted by mini-css-extract-plugin
export default {"link":"Vv3PCE","root":"t5kMDO","label":"q01bU3"};